import { render, staticRenderFns } from "./BlockedSimcard.vue?vue&type=template&id=1350a661&scoped=true"
import script from "./BlockedSimcard.vue?vue&type=script&lang=js"
export * from "./BlockedSimcard.vue?vue&type=script&lang=js"
import style0 from "./BlockedSimcard.vue?vue&type=style&index=0&id=1350a661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350a661",
  null
  
)

export default component.exports